import { stegaClean } from "@sanity/client/stega";

export const JOURNEY_COPY = {
  en: {
    labels: ["Profit Target", "Max Drawdown", "Position Loss"],
    chips: ["Hitting a realistic profit target", "Stay within the max drawdown", "Stay disciplined while trading", "Challenge account"],
    passed: "Challenge passed", you: "You", under: "Under", payout: "Payout", upTo: "Up to",
    cities: ["Frankfurt, Germany", "New York, USA", "London, UK", "Dubai, UAE"],
    descriptions: ["The IQ Capital Challenge: profit target, maximum drawdown and position loss.", "IQ Funded: trading days followed by payout notifications.", "IQ Elite: an exclusive global circle, institutional capital, coaching and flexible trading."],
    pause: "Pause animation", play: "Play animation", locale: "en-US",
  },
  de: {
    labels: ["Gewinnziel", "Max. Drawdown", "Positionsverlust"],
    chips: ["Ein realistisches Gewinnziel erreichen", "Den maximalen Drawdown einhalten", "Diszipliniert traden", "Challenge-Konto"],
    passed: "Challenge bestanden", you: "Du", under: "Unter", payout: "Auszahlung", upTo: "Bis zu",
    cities: ["Frankfurt, Deutschland", "New York, USA", "London, Großbritannien", "Dubai, VAE"],
    descriptions: ["Die IQ Capital Challenge: Gewinnziel, maximaler Drawdown und Positionsverlust.", "IQ Funded: Handelstage, gefolgt von Auszahlungsbenachrichtigungen.", "IQ Elite: ein exklusiver globaler Kreis, institutionelles Kapital, Coaching und flexibles Trading."],
    pause: "Animation pausieren", play: "Animation abspielen", locale: "de-DE",
  },
  br: {
    labels: ["Meta de lucro", "Drawdown máx.", "Perda por posição"],
    chips: ["Atingir uma meta de lucro realista", "Respeitar o drawdown máximo", "Operar com disciplina", "Conta Challenge"],
    passed: "Challenge aprovado", you: "Você", under: "Abaixo de", payout: "Saque", upTo: "Até",
    cities: ["Frankfurt, Alemanha", "Nova York, EUA", "Londres, Reino Unido", "Dubai, EAU"],
    descriptions: ["O Challenge da IQ Capital: meta de lucro, drawdown máximo e perda por posição.", "IQ Funded: dias de operação seguidos por notificações de saque.", "IQ Elite: círculo global exclusivo, capital institucional, mentoria e trading flexível."],
    pause: "Pausar animação", play: "Reproduzir animação", locale: "pt-BR",
  },
};

export function journeyCopy(language?: string) {
  const key = stegaClean(language);
  return JOURNEY_COPY[key === "de" || key === "br" ? key : "en"];
}

export function journeyAmount(value: number, locale: string) {
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(value);
}
